import React from "react";
import classNames from "classnames";
import { KpiDatum } from "../data";
import { KpiIcon, TrendArrow } from "../_shared/icons";
import styles from "./style.module.scss";

interface KpiStripProps {
  kpis: KpiDatum[];
}

/** Row of network-total KPI cards. */
export default function KpiStrip({ kpis }: KpiStripProps) {
  return (
    <div className={styles.grid}>
      {kpis.map((k) => (
        <div className={styles.card} key={k.label}>
          <div className={styles.top}>
            <div className={styles.iconBox}>
              <KpiIcon name={k.icon} />
            </div>
            {!k.delta ? null : k.neutral ? (
              <div className={classNames(styles.delta, styles.deltaNeutral)}>
                <span>{k.delta}</span>
              </div>
            ) : (
              <div className={k.up ? styles.deltaUp : styles.deltaDown}>
                <TrendArrow up={k.up} />
                <span>{k.delta}</span>
              </div>
            )}
          </div>
          <div>
            <div className={styles.value}>{k.value}</div>
            <div className={styles.label}>{k.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
